import React, { lazy, Suspense } from 'react';
import { render } from "react-dom";

const VehicleImage = lazy(() => import(/* webpackChunkName: "VehicleImage" */ './components/VehicleImage'));

const vehicleImageNodes = Array.from(document.querySelectorAll(".extranet-vehicle-image"));
if (vehicleImageNodes != null) {
    vehicleImageNodes.forEach(node => {
        const vehicleImage =
            typeof node.dataset.vehicleImage !== "undefined" ? node.dataset.vehicleImage : null;

        const updateUrl =
            typeof node.dataset.updateUrl !== "undefined" ? node.dataset.updateUrl : '';

        render(
            <Suspense fallback={<></>}>
                <VehicleImage image={vehicleImage} updateUrl={updateUrl} />
            </Suspense>,
            node
        );
    });
}
